export class NonActionableError extends Error {}
